import React, { useState, useEffect } from "react";
import axios from "axios";
import style from "./Program.module.css";
import programImage from "./images/pc.jpg";
import Header from "./header";
import MyFooter from "./my footer";
import { API_URL, ENDPOINTS } from "../../constants/api";
import { useNavigate} from "react-router-dom";

const Program = () => {
  const [faculties, setFaculties] = useState([]); // faculties list
  const [departments, setDepartments] = useState([]); // all departments
  const [selectedFaculty, setSelectedFaculty] = useState(null); // active faculty
  const [loading, setLoading] = useState(false);
  const navigate=useNavigate()

  const apiKey =
    "3f72ef31838a6cf7e082718614350592a56d06a57ba48e1206addf949b1734bd662265d87239cbd582ae3be050606943";

  // Fetch faculties
  useEffect(() => {
    const fetchFaculties = async () => {
      try {
        const res = await axios.get(
          `${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/web-facult-all`,
          {
            headers: { "x-api-key": apiKey },
          }
        );
        const data = res.data.report || [];
        setFaculties(data);

        if (data.length > 0) {
          setSelectedFaculty(data[0]); // default first faculty
        }
      } catch (err) {
        console.error("Error fetching faculties:", err);
      }
    };

    fetchFaculties();
  }, []);

  // Fetch ALL departments once
  useEffect(() => {
    const fetchDepartments = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/web-department-all`,
          {
            headers: { "x-api-key": apiKey },
          }
        );
        setDepartments(res.data.report || []);
      } catch (err) {
        console.error("Error fetching departments:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDepartments();
  }, []);

  // When faculty is clicked
  const handleFacultyClick = (faculty) => {
    setSelectedFaculty(faculty);
  };

  // Filter departments based on selected faculty
  const filteredDepartments = selectedFaculty
    ? departments.filter((dept) => dept.faculty_id === selectedFaculty.id)
    : [];

  return (
    <>
      <Header />

      <div className={style.appContainer}>
        {/* Header Section */}
        <header className={style.pageHeader}>
          <div className={style.headerContent}>
            <h1>All Faculties</h1>
            <p>University / Faculty / All Faculties</p>
          </div>
        </header>

        {/* Main Content */}
        <div className={style.contentArea}>
          <h2 className={style.sectionTitle}>Popular Programs (All Faculties)</h2>
          <div className={style.mainContent}>
            {/* Faculties Sidebar */}
            <div className={style.leftPanel}>
              <h3 className={style.panelTitle}>Our Faculties</h3>
              <ul className={style.facultyList}>
                {faculties.map((faculty) => (
                  <li
                    key={faculty.id}
                    className={`${style.facultyItem} ${
                      selectedFaculty?.id === faculty.id ? style.active : ""
                    }`}
                    onClick={() => handleFacultyClick(faculty)}
                  >
                    <span>{faculty.name}</span>
                    <span className={style.programCount}>
                      {
                        faculty.facult_count
                      }
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Departments */}
            <div className={style.rightPanel}>
              <div className={style.departmentDisplay}>
                {loading ? (
                  <p>Loading programs...</p>
                ) : filteredDepartments.length > 0 ? (
                  filteredDepartments.map((program) => (
                    <div key={program.id} className={style.programCard}>
                      <img
                        src={`${API_URL}/${program.image?.replace("public/", "")}`}
                        alt={program.name}
                        className={style.programImage}
                      />
                      <div className={style.cardContent}>
                        <h3>{program.name}</h3>
                        <p>${program.fee_monthly}/Month</p>
                        <div className={style.programDetails}>
                          <span>{program.courses} courses</span>
                          <span>{program.duration} </span>
                        </div>
                        <div className={style.programActions}>
                          <button className={style.btn}
                           onClick={() => navigate(`/department/${program.id}`)}
                          >Read More</button>
                          <a
                            className={`${style.btn} ${style.btnPrimary}`}
                            href={`/portal/New_Online_Student?department_id=${program.id}`}

                          >
                          Apply Now
                          </a>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className={style.noPrograms}>
                    No programs found for this faculty.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <MyFooter />
    </>
  );
};

export default Program;
